import { html } from 'lit';

export const iconText = html`
  <svg
    width="32"
    height="29"
    viewBox="0 0 32 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32 2.50447V6.51342C32 7.5783 30.9286 8.5179 29.7143 8.5179C28.4286 8.5179 27.4286 7.5783 27.4286 6.51342V4.50895H18.2857V24.5537H21.7143C22.9286 24.5537 24 25.4306 24 26.5582C24 27.623 22.9286 28.5 21.7143 28.5H10.2857C9 28.5 8 27.5604 8 26.5582C8 25.4933 9 24.5537 10.2857 24.5537H13.7143V4.50895H4.57143V6.51342C4.57143 7.5783 3.5 8.5179 2.28571 8.5179C1 8.5179 0 7.5783 0 6.51342V2.50447C0 1.37696 1 0.5 2.28571 0.5H29.7143C30.9286 0.5 32 1.37696 32 2.50447Z"
      fill="currentColor"
    />
  </svg>
`;
